import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { Centres } from '../model';

export const centresApi = createApi({
  reducerPath: 'centresApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/locations`,
    prepareHeaders: (headers) => {
      headers.set('X-API-KEY', process.env.REACT_APP_API_KEY as string);
      headers.set('Site-Id', process.env.REACT_APP_CURRENT_SITE_ID as string);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCentres: builder.query<Centres, void>({
      query: () => '/',
    }),
  }),
});

export const { useGetCentresQuery } = centresApi;
